// removed by extract-text-webpack-plugin
module.exports = {"spinner":"UsO13C1kTWW3CqFF"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Auth/LoginSmall.pcss
// module id = 462
// module chunks = 1